<template>
  <v-card
    class="mx-auto"
    outlined
  >
    <v-toolbar
      dense
    >
      <v-btn
        outlined
        rounded
        color="warning"
        class="mr-4"
        @click="cancel"
      >
        Назад
      </v-btn>
      <v-spacer />
      <v-btn
        outlined
        rounded
        color="success"
        class="mr-4"
        @click="submit"
      >
        Сохранить
      </v-btn>
    </v-toolbar>
    <form>
      <v-card class="px-5 mb-3">
        <fieldset
          style="border: thin solid #80808042"
          class="my-2"
        >
          <legend>Настройки работы в сервисе</legend>
          <v-row
            no-gutters
            class="px-4"
          >
            <v-col
              cols="12"
              class="px-3"
              :sm="12"
              :md="4"
            >
              <v-checkbox
                v-model="organization.isActive"
                label="Активная"
                required
              />
            </v-col>
            <v-col
              cols="12"
              class="px-3"
              :sm="12"
              :md="4"
            >
              <v-checkbox
                v-model="organization.hasAgencyContract"
                label="Агентский Договор"
              />
            </v-col>
            <v-col
              cols="12"
              class="px-3 py-3"
              :sm="12"
              :md="4"
            >
              <v-select
                v-model="organization.financialModel"
                :items="financialModelList"
                :disabled="!canEditFinanceStatus || !financialModelEditable"
                label="Финансовая модель"
                :item-text="'title'"
                :item-value="'id'"
                return-object
                :hint="financeStatusHint"
                :persistent-hint="!!financeStatusHint"
                required
              />
            </v-col>
            <!--            <v-col-->
            <!--              cols="12"-->
            <!--              class="px-3"-->
            <!--              :sm="12"-->
            <!--              :md="4"-->
            <!--            >-->
            <!--              <v-checkbox-->
            <!--                v-model="organization.isFinanceLess"-->
            <!--                :disabled="!canEditFinanceStatus"-->
            <!--                label="безлимитный баланс"-->
            <!--                @change="onFinanceChange"-->
            <!--              />-->
            <!--            </v-col>-->
          </v-row>
        </fieldset>
        <fieldset
          style="border: thin solid #80808042"
          class="my-2"
        >
          <legend>Профиль</legend>
          <v-row
            no-gutters
            class="px-4"
          >
            <v-col
              cols="12"
              class="px-3"
              :sm="12"
              :md="6"
            >
              <v-select
                v-model="organization.legalFormType"
                :items="dictionaries.legalFormTypeList"
                label="Правовая форма"
                :item-text="'title'"
                :item-value="'id'"
                return-object
                outlined
                required
              />
            </v-col>
            <v-col
              cols="12"
              class="px-3"
              :sm="12"
              :md="6"
            >
              <v-text-field
                v-model="organization.title"
                outlined
                label="Наименование Организации"
                required
              />
            </v-col>
            <v-col
              cols="12"
              class="px-3"
              :sm="12"
              :md="6"
            >
              <v-text-field
                v-model="organization.tradeMark"
                outlined
                label="Товарный знак"
                required
              />
            </v-col>
            <v-col
              cols="12"
              class="px-3"
              :sm="12"
              :md="6"
            >
              <v-text-field
                v-model="organization.kpp"
                outlined
                label="КПП"
                required
              />
            </v-col>
            <v-col
              cols="12"
              class="px-3"
              :sm="12"
              :md="6"
            >
              <v-text-field
                v-model="organization.inn"
                outlined
                label="ИНН"
                required
              />
            </v-col>
            <v-col
              cols="12"
              class="px-3"
              :sm="12"
              :md="6"
            >
              <v-text-field
                v-model="organization.telephone"
                outlined
                label="Телефон"
                required
              />
            </v-col>
            <v-col
              cols="12"
              class="px-3"
              :sm="12"
              :md="6"
            >
              <v-text-field
                v-model="organization.correspondentAccount"
                outlined
                label="Корреспондентский счет"
                required
              />
            </v-col>
            <v-col
              cols="12"
              class="px-3"
              :sm="12"
              :md="6"
            >
              <v-text-field
                v-model="organization.checkingAccount"
                outlined
                label="К/С"
                required
              />
            </v-col>
            <v-col
              cols="12"
              class="px-3"
              :sm="12"
              :md="6"
            >
              <v-text-field
                v-model="organization.accountant"
                outlined
                label="Главный бухгалтер"
                required
              />
            </v-col>
            <v-col
              cols="12"
              class="px-3"
              :sm="12"
              :md="6"
            >
              <v-text-field
                v-model="organization.address"
                outlined
                label="Фактический адрес"
                required
              />
            </v-col>
            <v-col
              cols="12"
              class="px-3"
              :sm="12"
              :md="6"
            >
              <v-text-field
                v-model="organization.legalAddress"
                outlined
                label="Юридический адрес"
                required
              />
            </v-col>
            <v-col
              cols="12"
              class="px-3"
              :sm="12"
              :md="6"
            >
              <v-text-field
                v-model="organization.director"
                outlined
                label="Директор"
                required
              />
            </v-col>
            <v-col
              cols="12"
              class="px-3"
              :sm="12"
              :md="6"
            >
              <v-text-field
                v-model="organization.bank.bik"
                outlined
                disabled
                label="Бик"
                required
              />
            </v-col>
            <v-col
              cols="12"
              class="px-3"
              :sm="12"
              :md="6"
            >
              <v-select
                v-model="organization.region"
                :items="dictionaries.regionList"
                label="Регион"
                :item-text="'title'"
                :item-value="'id'"
                return-object
                required
              />
            </v-col>
            <!--      <v-col cols="12"-->
            <!--        class="px-3"-->
            <!--        :sm="12"-->
            <!--        :md="6"-->
            <!--      >-->
            <!--        <v-checkbox-->
            <!--          v-model="organization.hasDelegatedSignature"-->
            <!--          label="Другой подписант в Договоре"-->
            <!--          required-->
            <!--        />-->
            <!--      </v-col>-->
            <v-col
              cols="12"
              class="px-3"
              :sm="12"
              :md="6"
            >
              <v-text-field
                v-model="organization.lunchSettingString"
                outlined
                label="Настройки перерыва (05ч 00мин: 20; 07ч 00мин: 40;)"
                :error="!isValid || !hasValidKeys || hasLunchDuplicateValues"
                :error-messages="getErrorMessage"
                persistent-hint
                :hint="'формат заполнения 05ч 00мин: 20; 07ч 00мин: 40; 10ч 00мин : 60'"
              />
            </v-col>
            <v-col
              cols="12"
              class="px-3"
              :sm="12"
              :md="6"
            >
              <v-text-field
                v-model="organization.maxRelayDuration"
                outlined
                label="Максимальная длительности смены в часах"
                required
                :max="17.5"
                :error="getMaxRelayDurationError"
                :error-messages="getMaxRelayDurationError? `Не более ${getMaxRelayDurationValue}` : undefined"
                type="number"
                hint="Длительность включает перерыв"
                persistent-hint
              />
            </v-col>
            <v-col
              cols="12"
              class="px-3"
              :sm="12"
              :md="6"
            >
              <v-text-field
                v-model="organization.maxRelayDuration"
                outlined
                label="Максимальная длительности смены в часах"
                required
                :max="17.5"
                :error="getMaxRelayDurationError"
                :error-messages="getMaxRelayDurationError? `Не более ${getMaxRelayDurationValue}` : undefined"
                type="number"
                hint="Длительность включает перерыв"
                persistent-hint
              />
            </v-col>
          </v-row>
        </fieldset>
        <fieldset
            style="border: thin solid #80808042"
            class="my-2"
        >
          <legend>Вводный инструктаж по охране труда</legend>
          <WBDFileUploader
              v-if="organization"
              @onFileDeleted="onFileDeleted"
              :mime-types="'application/pdf'"
              @onFileSaved="onFileSaved"
              icon
              :alias="'laborer-work-instruction'"
              :label="'Добавить вводный инструктаж по охране труда'"
              :model="organization.workSafetyInstruction" />

        </fieldset>

        <fieldset
          style="border: thin solid #80808042"
          class="my-2 py-4"
        >
          <legend>Логотип</legend>
          <v-row>
            <v-col
              cols="12"
              class="px-3"
              :sm="12"
              :md="6"
            >
              <v-btn
                v-if="organization.fileList.length === 0"
                class="mt-4"
                color="success"
                left
                small
                @click="onPickFile({
                  loadedEvent: eventNames.ORGANIZATION_FILE_LOADED,
                  deleteEvent: eventNames.ORGANIZATION_DELETE_FILE,
                  key: $route.params.id}
                )"
              >
                {{ 'Добавить логотип' }}
              </v-btn>
              <FileForm
                ref="docForm"
                :files="organization.fileList"
                :idx="$route.params.id"
              />
              <FileList
                :delete-event="eventNames.ORGANIZATION_DELETE_FILE"
                :files="organization.fileList"
                :title="''"
                hide-title
              />
            </v-col>
          </v-row>
        </fieldset>


        <v-card-actions class="my-1">
          <v-btn
            outlined
            rounded
            color="warning"
            class="mr-4"
            @click="cancel"
          >
            Назад
          </v-btn>
          <v-spacer />
          <v-btn
            outlined
            rounded
            color="success"
            class="mr-4"
            @click="submit"
          >
            Сохранить
          </v-btn>
        </v-card-actions>
      </v-card>
    </form>
    <ConfirmModal
      v-if="confirmModalEnabled"
      :displaySelf="!!confirmModalEnabled"
      :title="financeManagerDialogData.title"
      :message="financeManagerDialogData.message"
      @onCancelCallback="onCancelDeleteAction"
      @onSuccessCallback="onSuccessCallback"
    />
  </v-card>
</template>

<script>
import { validationMixin } from 'vuelidate'
// import { required } from 'vuelidate/lib/validators'
import DictionaryMixin from '@/mixins/dictionaryMixin'
import OrganizationMixin from '@/mixins/organizationMixin.vue'
import FileForm from '@/components/common/files/load/load-file-form.vue'
import FileList from '@/components/common/files/load/list.vue'
import { mapMutations } from 'vuex'
import storeUtils from '@/utils/store'
import storeLabel from '@/store/labels'
import ConfirmModal from '@/components/common/confirm-modal.vue'
import {
  FINANCIAL_MODEL_FINANCE_LESS,
  FINANCIAL_MODEL_FULL_MONEY,
  FINANCIAL_MODEL_STANDARD, LABEL_FINANCIAL_MODEL_FINANCE_LESS, LABEL_FINANCIAL_MODEL_FULL_MONEY,
  LABEL_FINANCIAL_MODEL_STANDARD
} from '@/views/organization/view'
import AppLogger from '@/utils/appLogger'
import WBDFileUploader from '@/components/common/files/file-uploader.vue'

export default {
  name: 'OrganizationFrom',
  components: {
    FileForm, FileList, ConfirmModal, WBDFileUploader
  },
  mixins: [validationMixin, DictionaryMixin, OrganizationMixin],
  validations: {
    organization: {
    }
  },
  props: {
    model: {
      type: Object
    },
    financialModelEditable: {
      type: Boolean
    }
  },
  data: () => ({
    financialModelList: [
      { id: FINANCIAL_MODEL_STANDARD, title: LABEL_FINANCIAL_MODEL_STANDARD },
      { id: FINANCIAL_MODEL_FULL_MONEY, title: LABEL_FINANCIAL_MODEL_FULL_MONEY },
      { id: FINANCIAL_MODEL_FINANCE_LESS, title: LABEL_FINANCIAL_MODEL_FINANCE_LESS },
    ],
    financeManagerDialogData: {
      title: 'Вы уверены что хотите менять финансовый статус данной организации?',
      message: 'Обратите внимание что операция не обратимо!',
    },
    initialFinanceStatus: null,
    confirmModalEnabled: false,
    financeStatus: null,
    dictionaries: { legalFormTypeList: [], regionList: [], },
    hasLunchDuplicateValues: false,
    organization: {
      'isActive': false,
      'hasAgencyContract': false,
      'title': null,
      'file': {
        'id': null
      },
      'fileList': [],
      'legalFormType': {
        'id': null
      },
      'region': {
        'id': null
      },
      'bank': {},
      'logo': {
        'id': null,
        'path': null,
      },
      'tradeMark': null,
      'inn': null,
      'kpp': null,
      'correspondentAccount': null,
      'checkingAccount': null,
      'bik': null,
      'address': null,
      'legalAddress': null,
      'telephone': null,
      'director': null,
      'accountant': null,
      'financialModel': null,
      'hasDelegatedSignature': false,
      'workSafetyInstruction': null,
      // 'organizationSignatoryAuthority': {
      //   'fullName': null,
      //   'profession': null,
      //   'authority': {
      //     'number': null,
      //     'dateOfIssue': null,
      //     'validUntil': null,
      //     'file': {
      //       'id': null
      //     }
      //   },
      //   'procuration': {
      //     'number': null,
      //     'dateOfIssue': null,
      //     'validUntil': null,
      //     'file': {
      //       'id': null
      //     }
      //   }
      // }
    }
  }),
  computed: {
    canEditFinanceStatus () {
      if (this.initialFinanceStatus) {
        return false
      }
      return this.getAppUserAccessManager.canManageOrganizationFinanceStatus(this.getLoggedUser)
    },
    financeStatusHint () {
      if (!this.canEditFinanceStatus) {
        return 'У вас нет прав на редактирование поле'
      }
      if (!this.financialModelEditable) {
        return 'Изменение модели не возможно'
      }
      return undefined
    },
    getMaxRelayDurationValue () {
      return 17.5
    },
    getMaxRelayDurationError () {
      if (!this.organization.maxRelayDuration) {
        return true
      }
      return parseFloat(this.organization.maxRelayDuration) > this.getMaxRelayDurationValue
    },
    getErrorMessage () {
      if (!this.isValid) {
        return 'Ошибка формата'
      }
      if (!this.hasValidKeys) {
        return 'Значения времени и перерыва должны быть возрастающие'
      }
      if (this.hasLunchDuplicateValues) {
        return 'Значения времени и перерыва должны быть возрастающие'
      }

      return undefined
    },
    isValid () {
      const { lunchSettingString } = this.organization
      if (!lunchSettingString) {
        return true
      }
      const reg = /^(\s+)?\d{2}(\s+)?ч(\s+)?\d{2}мин(\s+)?:(\s+)?\d{2}(\s+)?$/i

      return lunchSettingString.split(';').filter((item) => {
        return !item.match(reg)
      }).length === 0
    },
    hasValidKeys () {
      if (!this.isValid) {
        return true
      }

      const result = this.getLunchJsonValue()
      let counter = 0
      let prevValue = 0
      let prevKey = 0
      for (const [key, value] of Object.entries(result)) {
        if (counter > 0 && prevValue >= value) {
          return false
        }
        if (counter > 0 && prevKey >= key) {
          return false
        }
        prevKey = key
        prevValue = value
        ++counter
      }
      return true
    },
  },

  created () {
    if (this.model && this.model.id) {
      this.organization = { ...this.organization, ...this.model }
      if (this.model.logo && this.model.logo.id) {
        this.organization.fileList = [this.model.logo]
      }
      if (!this.organization.bank || !this.organization.bank.id) {
        this.organization.bank = {}
      }
    }

    this.eventsBus.$on(this.eventNames.ORGANIZATION_FILE_LOADED, this.onFileLoaded)
    this.eventsBus.$on(this.eventNames.ORGANIZATION_DELETE_FILE, this.onDeleted)
    this.loadDictionaries()

    AppLogger.info(this.financialModelEditable, 'self.OOOOOOO')

    // this.initialFinanceStatus = this.organization.isFinanceLess
  },
  methods: {
    ...mapMutations({
      setFileEvents: storeUtils.setterName(storeLabel.FILE_EVENTS, storeLabel.COMMON_MODULE),
    }),
    onFileLoaded (file) {
      this.checkFiles()
      this.loadFile(file.file, this.organization, 'organization')
    },
    onDeleted (index) {
      this.organization.fileList.splice(index, 1)
      this.checkFiles()
    },
    checkFiles () {
      this.showFileError = (!this.organization.fileList.length)
    },
    onPickFile (events) {
      this.setFileEvents(events)
      this.$el.querySelector(`#imageInput_${events.key}`).click()
    },
    submit () {
      this.$v.$touch()
      if (!this.isValid || !this.hasValidKeys || this.getMaxRelayDurationError || !this.organization.financialModel ||
          !this.organization.financialModel.id) {
        return
      }

      const {workSafetyInstruction} = this.organization
      this.createOrganization(
        {
          ...this.organization,
          financialModel: this.organization.financialModel.id,
          lunchSetting: this.getLunchJsonValue(),
          maxRelayDuration: parseFloat(this.organization.maxRelayDuration),
          workSafetyInstruction: workSafetyInstruction && workSafetyInstruction.id ?
              {id: workSafetyInstruction.id} : undefined,
        },
        (this.model && this.model.id && this.model.id !== 'new')
      )
    },
    getLunchJsonValue () {
      if (!this.isValid) {
        return null
      }
      const { lunchSettingString } = this.organization
      const lunchSettingStringArr = lunchSettingString.split(';')
      const jsonPared = {}

      let counter = 0
      let prevValue = 0
      let prevKey = 0
      let hasDuplicateValues = false

      for (const item of lunchSettingStringArr) {
        const parts = item.trim().split(':')
        const timeData = parts[0].trim().split(' ')
          .map((item) => {
            const parsed = parseInt(item.replace('ч', '', item).replace('мин', '', item), 10)
            return parsed
          },
          )

        const key = [timeData[0] * 60 + timeData[1]]
        const value = parseInt(parts[1], 10)
        // const result = { [`${key}`]: value }

        if (key && value) {
          jsonPared[key] = value
        }

        if (counter > 0 && prevValue >= value) {
          hasDuplicateValues = true
        }
        if (counter > 0 && prevKey >= key) {
          hasDuplicateValues = true
        }
        prevKey = key
        prevValue = value
        ++counter
      }

      this.hasLunchDuplicateValues = hasDuplicateValues
      return jsonPared
    },
    cancel () {
      window.location.reload()
    },
    onFinanceChange ($event) {
      this.confirmModalEnabled = true
      this.financeStatus = $event
      this.$nextTick(() => {
        this.organization.financialModel = !$event
      })
    },
    async loadDictionaries () {
      this.dictionaries.legalFormTypeList = await this.getDictionaries(
        'DICTIONARY_PATH',
        { params: { 'discr': 'organization_legal_form_type' } }
      )
      this.dictionaries.regionList = await this.getDictionaries('REGION_PATH')
    },
    clear () {
      this.$v.$reset()
      this.organization = null
    },
    onSuccessCallback () {
      const next = this.financeStatus
      this.confirmModalEnabled = false
      this.organization.isFinanceLess = next
      this.financeStatus = null
    },
    onCancelDeleteAction () {
      this.confirmModalEnabled = false
    },
    onFileDeleted (data) {
      this.organization.workSafetyInstruction = null
    },
    onFileSaved (data) {
      if(data && data.file && data.file.id) {
        this.organization.workSafetyInstruction = data.file
      } else {
        this.organization.workSafetyInstruction = null
      }
    },
  }
}
</script>
<style lang="scss" scoped>
    .office-item {
        cursor: pointer;
    }
</style>

